import { render, staticRenderFns } from "./item-editor-photo.vue?vue&type=template&id=212caa8d"
import script from "./item-editor-photo.vue?vue&type=script&lang=ts"
export * from "./item-editor-photo.vue?vue&type=script&lang=ts"
import style0 from "./item-editor-photo.vue?vue&type=style&index=0&id=212caa8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports